export const navlinksdata = [
    { _id: 1001, title: "Home", link: "home", isRoute: true, routePath: "/" },
    { _id: 1003, title: "Publications", link: "publications", isRoute: true, routePath: "/publications" },
    { _id: 1004, title: "Team", link: "meet-the-team", isRoute: true, routePath: "/team" },
    { _id: 1007, title: "Projects", link: "ongoing-projects", isRoute: true, routePath: "/ongoing-projects" },
    { _id: 1005, title: "Tools", link: "tool", isRoute: true, routePath: "/tools" },
    { _id: 1006, title: "Contact Us", link: "contact-us", isRoute: true, routePath: "/contact" },
    { _id: 1007, title: "Gallery", link: "gallery", isRoute: true, routePath: "/gallery"}
    // Add more routes if needed
  ];
  